import { useContext } from 'react';
import { SlaveDatasetContext } from '../../context/SlaveDatasetContext';

export const useSlaveDatasetContext = () => {
  const context = useContext(SlaveDatasetContext);

  if (context.isProvided === false) {
    throw new Error(
      'useSlaveDatasetContext must be used within a SlaveDatasetContextProvider'
    );
  }

  return context;
};
